import React, { Component } from 'react'

class TiempoRestante extends Component {
    state = {
        tiempo: ""
    }

    componentWillMount = () => {
        const getRemainTime = (deadline) => {
            let now = new Date(),
            remainTime = (new Date(deadline) - now + 1000) / 1000,
            remainSeconds = ('0' + Math.floor(remainTime % 60)).slice(-2),
            remainMinutes = ('0' + Math.floor(remainTime / 60 % 60)).slice(-2),
            remainHours = ('0' + Math.floor(remainTime / 3600 % 24)).slice(-2),
            remainDays = Math.floor(remainTime / (3600 * 24));

            return {
                remainTime,
                remainSeconds,
                remainMinutes,
                remainHours,
                remainDays
            }
        };

        const countdown = (deadline) => {
            let t = getRemainTime(deadline);
            let el = `${t.remainDays} dias, ${t.remainHours} horas, ${t.remainMinutes} minutos y ${t.remainSeconds} segundos`;
            this.setState({
                tiempo: el
            })
        };
        countdown(this.props.fechaFinal)
    }
    render() {

        const getRemainTime = (deadline) => {
            let now = new Date(),
            remainTime = (new Date(deadline) - now + 1000) / 1000,
            remainSeconds = ('0' + Math.floor(remainTime % 60)).slice(-2),
            remainMinutes = ('0' + Math.floor(remainTime / 60 % 60)).slice(-2),
            remainHours = ('0' + Math.floor(remainTime / 3600 % 24)).slice(-2),
            remainDays = Math.floor(remainTime / (3600 * 24));

            return {
                remainTime,
                remainSeconds,
                remainMinutes,
                remainHours,
                remainDays
            }
        };

        const countdown = (deadline) => {
            const timerUpdate = setInterval( () => {
                let t = getRemainTime(deadline);
                let el = `${t.remainDays} dias, ${t.remainHours} horas, ${t.remainMinutes} minutos y ${t.remainSeconds} segundos`;
                if (t.remainTime <= 1) clearInterval(timerUpdate);

                this.setState({tiempo: el})
            }, 1000);
        };

        countdown(this.props.fechaFinal);

        return (
            <div className="text-danger" align="center" style={{fontSize: 10, fontWeight:"bold"}}>{this.state.tiempo}</div>
        );
    }
}
 
export default TiempoRestante;


// WEBPACK FOOTER //
// ./src/site/Componentes/TiempoRestante.jsx